angular.module('am4')
.factory('mapsService', function($http, apiUrl) {
    return {
        getAll: function(facilityId) {
            return $http.get(apiUrl + '/facilities/' + facilityId + '/facility_map')
            .then(function(res) {
                return res.data;
            });
        },
        get: function(mapId, facilityId) {
            return $http.get(apiUrl + '/facilities/' + facilityId + '/facility_map/' + mapId)
            .then(function(res) {
                return res.data;
            });
        },
        create: function(facilityId, image, name, description) {
            var fd = new FormData();
            fd.append('image', image);
            fd.append('name', name);
            fd.append('description', description);

            return $http.post(apiUrl + '/facilities/' + facilityId + '/facility_map', fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            })
            .then(function(res) {
                return res.data;
            });
        },
        deactivate: function(mapId, facilityId) {
            return $http.delete(apiUrl + '/facilities/' + facilityId + '/facility_map/' + mapId)
            .then(function(res) {
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/maps.js